import React from 'react';
import { Grid, Typography, Paper, withStyles } from '@material-ui/core';
import { components } from '@peachjar/components';

const styles = {
  page: {
    padding: '56px 66px',
    marginBottom: 100,
    width: '100%',
  },
  pageContainer: {
    maxWidth: 1300,
    margin: '0 auto',
    paddingTop: 72 - 16,
  },
};

const GoLivePage = ({ classes, title, children }) => (
  <Grid container className={classes.pageContainer}>
    <Grid item xs={12}>
      <Typography variant="display1">{title}</Typography>
    </Grid>
    <Paper className={classes.page}>{children}</Paper>
  </Grid>
);

export default withStyles(styles)(GoLivePage);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/go-live/elements/PaperPage.jsx